import React from "react";
import Typography from "@material-ui/core/Typography";
import "./Recordcom.css";
const Redrecord1 = ({ bgcolor, numresult, period }) => {
  const typecast = period.toString();
  const first = typecast.substring(9, 12);
 

  return (
    <>
      <div className="record-main-no">
        <Typography
          style={{ fontSize: "10px", marginLeft: "10px" }}
          justifyContent="center"
        >
          {first}
        </Typography>
        <div
          className="recordcomm"
          style={{background:bgcolor }}
        >
          <span >{numresult}</span>
        </div>
      </div>
    </>
  );
};

export default Redrecord1;
